// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZsDEahNLRUIrziUa{display:flex;align-items:center;flex-direction:column}.ZsDEahNLRUIrziUa .SC44ZEVD5eQgG7vR{width:90%;text-align:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentContainer": `ZsDEahNLRUIrziUa`,
	"content": `SC44ZEVD5eQgG7vR`
};
export default ___CSS_LOADER_EXPORT___;
